console.log("🚀 Le script translate-appointment-popup.js est chargé !");

if(window.location.pathname.includes("/en/")) {
    window.addEventListener("load", function () {
        translateAppointmentPopup();

        function translateAppointmentPopup() {
            const slotsDiv = document.getElementById("slotsRootEmbeded");

            if (!slotsDiv) {
                console.warn("⚠️ La div #slotsRootEmbeded n'est pas encore présente.");
                return;
            }

            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        console.log("✅ La div #slotsRootEmbeded a été ajoutée !");
                        const placeholder = document.querySelector('#react-select-2-placeholder');
                        const days = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
                        const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
                        const monthsEN = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

                        if (placeholder) {
                            $('#react-select-2-placeholder').text(translationsForAppointment.confirm_store)
                        } else {
                            console.warn("⚠️ La div #react-select-2-placeholder n'est pas encore présente.");
                            return;
                        }

                        days.forEach(day => {
                            const abbr = document.querySelector(`abbr[title="${day}"]`);
                            if (abbr) {
                                abbr.textContent = translationsForAppointment[day];
                            } else {
                                console.warn(`⚠️ L'abbréviation pour le jour ${day} n'est pas encore présente.`);
                                return;
                            }
                        });

                        months.forEach((month, index) => {
                            const abbr = document.querySelector('.react-calendar__navigation__label span');
                            if (abbr) {
                                abbr.textContent = abbr.textContent.replace(month, translationsForAppointment[monthsEN[index]]);
                            } else {
                                console.warn(`⚠️ L'abbréviation pour le mois ${month} n'est pas encore présente.`);
                                return;
                            }
                        });

                        observeMonths();
                        observeScheduleAppointment();

                        observer.disconnect();
                    }
                }
            });

            observer.observe(slotsDiv, {childList: true, subtree: true});
        }

        function observeScheduleAppointment() {
            const scheduleAppointment = document.querySelector(".schedule_appointment");
            if (!scheduleAppointment) {
                console.warn("⚠️ Le bouton .schedule_appointment n'est pas encore présent.");
                return;
            }

            const secondaryObserver = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        const sltButton = document.querySelector(".schedule_time_wrapper__footer .slt-button");
                        if (sltButton) {
                            sltButton.textContent = translationsForAppointment.continue;

                            observeScheduleFormAppointment();

                            secondaryObserver.disconnect();
                        } else {
                            console.warn("⚠️ Le bouton .slt-button n'est pas encore présent.");
                            return;
                        }
                    }
                }
            });

            secondaryObserver.observe(scheduleAppointment, {childList: true, subtree: true});
        }

        function observeMonths() {
            const buttons = document.querySelector('.react-calendar__navigation');
            const span = document.querySelector('.react-calendar__navigation__label__labelText');
            const monthsKeys = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
            const monthsKeysEN = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

            buttons.addEventListener('click', function (e) {
                setTimeout(() => {
                    monthsKeys.forEach((month, index) => {
                        span.textContent = span.textContent.replace(month, translationsForAppointment[monthsKeysEN[index]]);
                    });
                }, 10);
            });
        }

        function observeScheduleFormAppointment() {
            const scheduleFormAppointment = document.querySelector("#slotsRootEmbeded");
            if (!scheduleFormAppointment) {
                console.warn("⚠️ #slotsRootEmbeded n'est pas encore présent.");
                return;
            }

            const thirdObserver = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === "childList") {
                        const scheduleForm = document.querySelector(".schedule_form");
                        if (scheduleForm) {
                            const nameInput = document.querySelector("input[placeholder='Nom']");
                            const phoneInput = document.querySelector("input.PhoneInputInput");
                            const messageTextarea = document.querySelector("textarea[placeholder='Votre message']");
                            const submitButton = document.querySelector(".confirm_btn input");
                            const checkboxText = document.querySelector(".container_checkbox.comfirm_checkbox div");
                            const sltBadge = document.querySelector(".slt-badge");

                            if (nameInput) {
                                nameInput.placeholder = translationsForAppointment.name;
                            } else {
                                console.warn("⚠️ L'input pour le nom n'est pas encore présent.");
                                return;
                            }

                            if (phoneInput) {
                                phoneInput.placeholder = translationsForAppointment.phone;
                            } else {
                                console.warn("⚠️ L'input pour le téléphone n'est pas encore présent.");
                                return;
                            }

                            if (messageTextarea) {
                                messageTextarea.placeholder = translationsForAppointment.your_message;
                            } else {
                                console.warn("⚠️ Le textarea pour le message n'est pas encore présent.");
                                return;
                            }

                            if (submitButton) {
                                submitButton.value = translationsForAppointment.confirm;
                            } else {
                                console.warn("⚠️ Le bouton de confirmation n'est pas encore présent.");
                                return;
                            }

                            if (checkboxText) {
                                checkboxText.textContent = translationsForAppointment.agree_checkbox_text_html;
                                checkboxText.outerHTML = checkboxText.outerHTML.replace(
                                    "$LINK",
                                    '<a href="/en/pages/conditions-generales-dutilisation" target="_blank">' + translationsForAppointment.general_conditions + '</a>'
                                );
                            } else {
                                console.warn("⚠️ Le texte de la checkbox n'est pas encore présent.");
                                return;
                            }

                            if (sltBadge) {
                                const sltDaysToReplace = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
                                const days = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
                                sltDaysToReplace.forEach((day, index) => {
                                    sltBadge.textContent = sltBadge.textContent.replace(day, translationsForAppointment[days[index]]);
                                });
                            } else {
                                console.warn("⚠️ Le badge pour le slot sélectionné n'est pas encore présent.");
                                return;
                            }
                        } else {
                            console.warn("⚠️ Le formulaire .schedule_form n'est pas encore présent.");
                            return;
                        }

                        thirdObserver.disconnect();
                    }
                }
            });

            thirdObserver.observe(scheduleFormAppointment, {childList: true, subtree: true});
        }
    });
}